import React from "react";

export default function Error() {
  return (
    <div>
      <p>Path does not exist</p>
    </div>
  );
}
